/** 지식 파일 03: 변화 지점 판단기준 */
export const CHANGE_POINTS_MD = `# 03 변화 지점 판단기준 (v1)

축어록·대화록 구간은 "감정 단어가 많은 곳"이 아니라 **내담자에게 무엇이 움직인 곳**이다.
변화 지점은 항상 **변화 전 신호 → 계기(상담자 개입 등) → 변화 후 신호**로 확인하고, 각각의 발언 번호(segmentId)를 적는다.
구간은 변화 전후 맥락이 들어가도록 10~15분으로 잡는다.

## 판단 틀

### 1. 경험의 깊어짐 — 경험 척도 (Eugene Gendlin, Marjorie Klein)
- 전: 사건을 외적으로 보고, 일반론("다들 그렇잖아요"), 감정 없이 설명.
- 후: 자기 느낌을 직접 말함("그때 사실 무서웠어요"), 느낌을 탐색하며 새 의미가 생김.
- 계기 예: 감정 반영, 포커싱 질문, 침묵을 견딤.

### 2. 문제 경험의 동화 — 동화 척도 APES (William B. Stiles)
- 단계: 0 회피 → 1 원치 않는 생각 → 2 막연한 인식 → 3 문제 진술·명료화 → 4 이해·통찰 → 5 적용·작업 → 6 해결 → 7 숙달.
- 변화 지점 = 한 단계 이상 올라가는 순간 (예: 막연한 불편함 → "실수하면 버려질 것 같아서였어요"라는 명료한 진술).

### 3. 정서 처리의 전환 — 정서중심 표식 (Leslie Greenberg)
- 표식: 자기비판 분열(나를 깎아내리는 목소리 vs 상처받는 나), 미해결 과제, 이해 안 되는 내 반응, 취약성.
- 변화: 이차 정서(짜증·무기력) → 일차 정서(슬픔·두려움) 도달 → 자기자비·주장으로 변화.

### 4. 생각의 전환 — 인지적 변화 (Aaron Beck)
- 전: 자동적 사고를 사실처럼 말함 ("저는 원래 부족해요").
- 후: 생각을 생각으로 봄, 대안적 해석, 증거 재평가 ("그게 꼭 부족해서만은 아니었을 수도 있겠네요").

### 5. 통찰 — 통찰 사건 (Clara Hill)
- 새로운 연결: 현재 문제 ↔ 과거 경험 ↔ 관계 패턴 ("엄마한테 혼날까 봐 그랬던 거랑 똑같네요").
- 확인: 내담자 스스로의 말로 연결이 나와야 한다 (상담자 해석에 단순 동의는 통찰로 보지 않는다).

### 6. 새로운 이야기 — 혁신적 순간 (Miguel Gonçalves)
- 종류: 행동(문제와 다르게 행동), 성찰(새 이해), 저항(문제에 맞섬), 재개념화(전·후 대비), 새로운 경험 수행.
- 예: "이번에는 실수했을 때 그냥 넘어가 봤어요."

### 7. 관계의 균열과 회복 — 동맹 균열-회복 (Jeremy Safran, J. Christopher Muran)
- 균열: 위축(말이 짧아짐, 화제 전환, 지나친 동의) 또는 대립(불만, 반박).
- 회복: 상담자가 알아차리고 지금-여기에서 다룸 → 내담자가 욕구·불편을 말함. 수퍼비전 가치가 큼.

### 8. 의미 있는 사건 — 도움이 된 사건 (Robert Elliott)
- 내담자가 직접 "그 말이 도움이 됐다", "처음 해 보는 생각이에요"라고 말한 순간과 그 직전 개입.

### 9. 양가감정의 움직임 — 동기강화 (William Miller, Stephen Rollnick)
- 유지대화("못 할 것 같아요") 비율이 줄고 변화대화("해 보고 싶어요", "할 수 있을 것 같아요")가 늘어나는 순간.

### 10. 영적 전환 (목회상담)
- 하나님·신앙에 대한 표현이 수치·두려움 중심에서 은혜·수용·의미 중심으로 옮겨가는 순간, 또는 그 반대의 위기 순간. 신앙 언어는 내담자의 말 그대로 인용한다.

## 변화 지점이 아닌 것
- 상담자의 해석에 "네, 맞아요"로만 답한 곳 (동의일 뿐 변화 근거가 약함)
- 사건 보고가 길기만 하고 경험·의미의 움직임이 없는 곳
- 화자 판정이 불확실한 줄([추정]·[불명])만으로 이루어진 곳

## 쓰는 형식
- type: 위 1~10 중 이름 (예: "경험의 깊어짐")
- theory: 근거 이론 (대표 학자)
- beforeSegmentIds / afterSegmentIds: 전·후를 보여주는 발언
- whatChanged: 무엇이 무엇으로 바뀌었는지 한두 문장
- meaning: 사례개념화·목표와의 연결
- supervisionQuestions: 그 구간에서 상담자 개입에 대해 물을 질문
`;
